import { httpGet } from '@/services/http';

/** Plan interface matching backend data */
export interface Plan {
  id: number;
  title: string;
  title_en: string;
  period: string;
  period_en: string;
  theme: string;
  theme_en: string;
  audience: string;
  audience_en: string;
  tags: string[];
  tags_en: string[];
  sort_order: number;
  status: string;
  created_at: string;
  updated_at: string;
}

/** GET /api/public/plans - 获取所有活动计划 */
export async function getPublicPlans(): Promise<Plan[]> {
  try {
    const data = await httpGet<Plan[]>('/public/plans');
    return data || [];
  } catch (error) {
    console.error('获取活动计划失败:', error);
    return [];
  }
}

/** GET /api/public/plans/:id - 获取单个活动计划 */
export async function getPublicPlanById(id: string): Promise<Plan | null> {
  try {
    const data = await httpGet<Plan>(`/public/plans/${id}`);
    return data;
  } catch (error) {
    console.error('获取活动计划详情失败:', error);
    return null;
  }
}
